module.exports = __webpack_public_path__ + "img/11@2x.2b670bd6.png";